<template>
  <div>
    <transition name="route" mode="out-in">
      <PreLoader v-if="allIsLoading" />
    </transition>
    <div class="container form-row" data-aos="fade-up">
      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <button
            class="btn-img-outer"
            @click="scrollToSection('aggregator-sect')"
          >
            <img
              class="card-img-top"
              :src="this.publicPath + 'assets/img/pngs/aggregator.png'"
              alt="aggregator"
            />
          </button>
        </div>
      </div>
      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <button
            class="btn-img-outer"
            @click="scrollToSection('branded-sect')"
          >
            <img
              class="card-img-top"
              :src="this.publicPath + 'assets/img/pngs/aggregator-branded.png'"
              alt="aggregator branded"
            />
          </button>
        </div>
      </div>
      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <button class="btn-img-outer" @click="scrollToSection('crm-sect')">
            <img
              class="card-img-top"
              :src="this.publicPath + 'assets/img/pngs/crm-engine.png'"
              alt="crm engine"
            />
          </button>
        </div>
      </div>

      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <button
            class="btn-img-outer"
            @click="scrollToSection('platform-sect')"
          >
            <img
              class="card-img-top"
              :src="this.publicPath + 'assets/img/pngs/platform-w.png'"
              alt="platform"
            />
          </button>
        </div>
      </div>

      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <button
            class="btn-img-outer"
            @click="scrollToSection('slot-engine-sect')"
          >
            <img
              class="card-img-top"
              :src="this.publicPath + 'assets/img/pngs/slot-engine-builder.png'"
              alt="slot engine and builder"
            />
          </button>
        </div>
      </div>
      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <button
            class="btn-img-outer p-3"
            @click="scrollToSection('slot-section')"
          >
            <img
              class="card-img-top"
              :src="this.publicPath + 'assets/img/pngs/slots.png'"
              alt="slots"
            />
          </button>
        </div>
      </div>
    </div>
    <div>
      <CasinoAggregatorSolution />
      <CrmEngineSolution />
      <ThePlatformSectionSolution />
      <WhyUs />
      <PreviewGamesHomePage />
      <OurProviders />
    </div>
  </div>
</template>

<script>
import PreLoader from "@/components/Global/PreLoader.vue";
import ThePlatformSectionSolution from "@/components/UI/ThePlatformSectionSolution.vue";
import CasinoAggregatorSolution from "@/components/UI/CasinoAggregatorSolution.vue";
import CrmEngineSolution from "@/components/UI/CrmEngineSolution.vue";
import OurProviders from "@/components/UI/OurProviders.vue";
import WhyUs from "@/components/UI/WhyUs.vue";
import PreviewGamesHomePage from "@/components/UI/PreviewGamesHomePage.vue";
export default {
  name: "OurSolutions_Page",
  components: {
    PreLoader,
    ThePlatformSectionSolution,
    CasinoAggregatorSolution,
    CrmEngineSolution,
    OurProviders,
    PreviewGamesHomePage,
    WhyUs,
  },

  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
      lang: localStorage.getItem("language") ?? "en",
      loadingComplete: false,
      allIsLoading: true,
    };
  },
  computed: {},
  mounted() {},
  created() {
    let lang = localStorage.getItem("language");
    this.$router.push({ params: { lang: lang } });
    document.body.style.fontFamily = "Poppins, sans-serif";
    this.setMetaTags();
    this.timeout();
  },
  methods: {
    timeout() {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      setTimeout(() => {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
        this.allIsLoading = false;
      }, 1500);
    },
    setMetaTags() {
      const title = "The Ear | Our Solutions";
      const metaDescription = "The Ear aims to offer high quality services.";
      document.title = title;

      const metaDescriptionTag = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute("content", metaDescription);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.name = "description";
        newMetaTag.content = metaDescription;
        document.head.appendChild(newMetaTag);
      }
    },
    scrollToSection(sectionId) {
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        const sectionElement1 = sectionElement.getBoundingClientRect();
        window.scrollTo({
          left: sectionElement1.left + window.scrollX,
          top: sectionElement1.top + window.scrollY - 35,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @media (min-width: 767px) {
    padding-top: 140px;
  }
  padding-top: 100px;
  max-width: 990px;
}

.section-solution-preview-bg {
  background-color: #09041f;
  position: relative;
  background-size: cover;
  padding: 26px 0 94px;
}

.section-solution-preview {
  max-width: 1320px;
  width: 100%;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.col-md-4 {
  flex: 0 0 33.333%;
  max-width: 33.333%;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

@media (max-width: 576px) {
  .col-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}

.card {
  width: 100%;
  border: 0px;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 95px;
  border: 0px solid transparent;
}

.btn-img-outer {
  background: rgb(22, 33, 52);
  padding: 5px 10px;
  border-radius: 5px;
  height: 100%;
  width: 100%;
}

.card-img-top {
  -webkit-backdrop-filter: blur(50px);
  backdrop-filter: blur(50px);
  max-width: 250px;
  -o-object-fit: contain;
  object-fit: contain;
  height: auto;
  -webkit-backdrop-filter: 1px 1px 1px 1xp black;
  min-height: 100%;
  aspect-ratio: 4 / 1;
  height: 100%;
}
</style>
